import styled from 'styled-components';
import { Container, Row, Col } from 'react-bootstrap';
import { PRIMARY } from '../../utils/colors';

export const AboutUsContainer = styled(Container)`
  font-family: 'Figtree', sans-serif;
  padding: 80px 20px;
  background-color: #f9fafb;
`;

export const AboutUsRow = styled(Row)`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  text-align: center;
  margin-bottom: 40px;
`;

export const SectionTitle = styled.h2`
  font-family: 'FigtreeBold', sans-serif;
  font-size: 2rem;
  font-weight: 600;
  color: ${PRIMARY};
  margin-bottom: 1rem;
`;

export const StorySubtitle = styled.h3`
  font-family: 'FigtreeBold', sans-serif;
  font-size: 1.5rem;
  color: ${PRIMARY};
  margin-bottom: 1rem;
`;

export const Subtitle = styled.p`
  font-size: 1rem;
  color: #475569;
  max-width: 600px;
`;

export const AboutUsImageCol = styled(Col)`
  padding: 0 20px;
  @media (max-width: 768px) {
    order: 1;
    margin-bottom: 20px;
  }
`;

export const AboutUsContentCol = styled(Col)`
  padding: 0 20px;
  text-align: left;
  @media (max-width: 768px) {
    order: 2;
  }
`;

export const AboutUsImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 16px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
`;

export const StoryText = styled.p`
  color: #1e293b;
  font-size: 1rem;
  margin-top: 1rem;
  line-height: 1.6;
`;

export const CardGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem;
  margin-top: 2rem;
`;

export const InfoCard = styled.div`
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
  padding: 1.5rem;
  flex: 1;
  min-width: 250px;
  text-align: center;
  transition: box-shadow 0.3s ease, transform 0.3s ease;

  &:hover {
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
    transform: translate(0px, -3.99328px);
  }
`;

export const IconCircle = styled.div`
  background-color: #e2e8f0;
  border-radius: 9999px;
  width: 100px;
  height: 100px;
  margin: 0 auto 0.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Image = styled.img`
  width: 100%;
  height: 100%;
`;

export const CardTitle = styled.h4`
  font-size: 1.1rem;
  font-family: 'FigtreeBold', sans-serif;
  margin-bottom: 0.5rem;
`;

export const CardDescription = styled.p`
  font-size: 0.95rem;
  color: #334155;
`;
